// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const borderRadius = 8;
export const basename = '/free';
export const defaultPath = '/dashboard/default';
export const fontFamily = `'Roboto', sans-serif`;

export const sortList = [
	{ id: 'createdAt', title: 'По дате' },
	{ id: 'title', title: 'По наименованию' },
	{ id: 'done', title: 'По выполнению' },
	{ id: 'visibleStages', title: 'По оплате' },
];

export const setColor = {
	true: {
		dark: {
			done: {
				bg: '#255226',
				color: '#9ff1a5',
			},
			start: {
				bg: '#f1c40f',
				color: '#121212',
			},
			default: {
				bg: '#121212',
				color: '#fff',
			},
		},
		light: {
			done: {
				bg: '#a5d6a7',
				color: '#121212',
			},
			start: {
				bg: '#fbff17',
				color: '#121212',
			},
			default: {
				bg: '#d3d3d3',
				color: '#121212',
			},
		},
	},
	false: {
		dark: {
			done: {
				bg: '#7a3b27',
				color: '#b9b9b9',
			},
			start: {
				bg: '#7a3b27',
				color: '#b9b9b9',
			},
			default: {
				bg: '#7a3b27',
				color: '#b9b9b9',
			},
		},
		light: {
			done: {
				bg: '#ffad93',
				color: '#121212',
			},
			start: {
				bg: '#ffad93',
				color: '#121212',
			},
			default: {
				bg: '#ffad93',
				color: '#121212',
			},
		},
	},
};

export const palette = {
	dark: {
		info: '#42a5f5',
	},
	light: {
		info: '#1565c0',
	},
};